/** @format */

import React, {useEffect, useState} from 'react'

import {FullPageLoading} from '@src/components/Loading'

import ajax from '@src/ajax'
import {formbutton} from '@src/utils'

export const AllFormsContext = React.createContext({})

export const AllFormsContextProvider = ({children}) => {
  const [forms, setForms] = useState([])
  const [ready, setReady] = useState(false)

  const reloadAllForms = async () => {
    /* caveat: doesn't update current form state */
    setReady(false)
    await ajax({
      method: 'GET',
      // Removing 'detailed' should grab just the necessary data to load the dashboard
      endpoint: '/api-int/forms?detailed=true',
      onSuccess: r => {
        setForms([...r.forms])
        formbutton()('set', {'Num Forms': r.forms.length})
        setReady(true)
      },
      errorMsg: 'Error fetching forms list',
    })
  }

  useEffect(() => {
    reloadAllForms()
  }, [])

  if (!ready) {
    return <FullPageLoading />
  }

  return (
    <AllFormsContext.Provider
      value={{
        forms,
        setForms,
        reloadAllForms,
      }}
    >
      {children}
    </AllFormsContext.Provider>
  )
}
